<script setup lang="ts">
import type { Locale } from "~/constants";

const router = useRouter();
const route = useRoute();
const localeRoute = useLocaleRoute();
const { locale } = useI18n();

const languages: {
  label: string;
  value: Locale;
  prefixSrc: string;
}[] = [
  {
    label: "Lietuvių",
    value: "lt",
    prefixSrc: "/icons/flags/lt.svg",
  },
  {
    label: "English",
    value: "en",
    prefixSrc: "/icons/flags/en.svg",
  },
  {
    label: "Русский",
    value: "ru",
    prefixSrc: "/icons/flags/ru.svg",
  },
];

const selectedLocale = computed(() => locale.value);
const selectedLocaleText = computed(() => selectedLocale.value.toUpperCase());

function handleSubmit(lang: string) {
  const nextLocale = lang as Locale;

  if (locale.value === nextLocale) return;

  const localizedRoute = localeRoute(
    {
      path: route.path,
      query: route.query,
    },
    nextLocale,
  );

  if (localizedRoute) {
    router.push(localizedRoute);
  }
}
</script>

<template>
  <AppSelect
    :model-value="selectedLocale"
    :selected-text="selectedLocaleText"
    :options="languages"
    align="right"
    width="sm"
    value-class="uppercase text-app-text"
    placeholder-class="uppercase text-app-muted"
    trigger-class="flex min-h-10 items-center gap-2 rounded-lg px-2.5 py-2 text-sm font-semibold text-app-text transition duration-300 hover:bg-[#F5F8F7]"
    open-trigger-class="bg-[#F5F8F7]"
    option-class="!rounded-lg !py-2.5 !px-3"
    list-class="!divide-y-0 gap-1 p-1.5"
    @update:model-value="handleSubmit"
  />
</template>
